import {
  BaseUserRegistrationRequest,
  EventUserStatusAffEnum,
  SeriesEventRegistrationRequest,
  listRegistrants,
  registerUsersToEventsInSeries
} from '@goldcast/api/backend';
import logger from '@goldcast/logger';

import { transformSeriesRegistrants } from '@/studio/series/registration/registrants/utils';

const actions = {
  async fetchRegistrants({ dispatch, commit, state, getters }, { seriesId }: { seriesId: string }) {
    const { orderBy, seriesRegistrantsPerPage, seriesRegistrantsCurrentPage, seriesRegistrantsSearchTerm } = state;
    const { getSelectedColumnFilterTitles } = getters;

    const companyFilterTitles = getSelectedColumnFilterTitles({ columnKey: 'company' });
    const eventsFilterTitles = getSelectedColumnFilterTitles({ columnKey: 'events' });
    let updatedOrderBy: string = orderBy;

    if (orderBy.includes('full_name')) {
      updatedOrderBy = orderBy.replace('full_name', 'first_name');
    }

    commit('setIsSeriesRegistrantsLoading', true);

    try {
      const seriesRegistrants = await listRegistrants({
        series_id: seriesId,
        queryParams: {
          ordering: updatedOrderBy || '',
          company__in: companyFilterTitles,
          events__in: eventsFilterTitles,
          limit: seriesRegistrantsPerPage,
          offset: (seriesRegistrantsCurrentPage - 1) * seriesRegistrantsPerPage,
          search: seriesRegistrantsSearchTerm
        }
      });

      const seriesRegistrantList = transformSeriesRegistrants(seriesRegistrants.results || []);

      commit('setSeriesRegistrants', seriesRegistrantList);
      commit('setSeriesRegistrantsCount', seriesRegistrants.count);
      return seriesRegistrants.results;
    } catch (error) {
      dispatch('studioToast/triggerToast', { msg: 'Error fetching registrants!', mode: 'error' }, { root: true });
      logger.error(error);
    } finally {
      commit('setIsSeriesRegistrantsLoading', false);
    }
  },
  fetchSeriesRegBuilderData({ rootGetters }, currentSeriesId: string) {
    const currentSeries = rootGetters['studioSeriesList/getCurrentSeriesById'](currentSeriesId);

    if (currentSeries && currentSeries.builder_raw_json) {
      return fetch(currentSeries.builder_raw_json).then(res => res.text());
    }
    return null;
  },
  async registerUserForSeries(
    { dispatch },
    {
      series_id,
      form_id,
      userData,
      events,
      eventUserStatus
    }: {
      series_id: string;
      form_id: string;
      userData: BaseUserRegistrationRequest;
      events: SeriesEventRegistrationRequest[];
      eventUserStatus: EventUserStatusAffEnum;
    }
  ) {
    try {
      await registerUsersToEventsInSeries({
        series_id,
        body: {
          events,
          form_id,
          user: userData,
          event_user_status: eventUserStatus
        }
      });
      dispatch(
        'studioToast/triggerToast',
        {
          msg: 'Your user will now be registered. It may take a few minutes for registration to be processed.',
          mode: 'success'
        },
        { root: true }
      );
    } catch (error) {
      dispatch(
        'studioToast/triggerToast',
        { msg: 'Error registering user for Series, Please Try Again', mode: 'error' },
        { root: true }
      );
      logger.error(error);
    }
  }
};

export default actions;
